module.exports = __webpack_public_path__ + "media/tap.65fd0826.mp3";